
export default function About() {
  const promises = [
    {
      title: "Quality Across Brands",
      description: "We are brand-agnostic but partner with the most reliable names in the industry. Every product we distribute is tested against international quality, performance, and safety standards.",
      icon: "ri-shield-check-line"
    },
    {
      title: "Technical Support",
      description: "Distribution is only the beginning. We provide on-ground support, design inputs, and applicator training to ensure long-term durability.",
      icon: "ri-tools-line"
    },
    {
      title: "Pan-India Reach, Local Understanding",
      description: "From metros to tier-2/3 cities, we understand regional challenges (climate, substrates, logistics) and customize solutions accordingly.",
      icon: "ri-map-2-line"
    },
    {
      title: "Timely Delivery & Logistics",
      description: "With efficient inventory management and logistics, we ensure your projects never face downtime due to lack of material.",
      icon: "ri-truck-line"
    },
    {
      title: "Project & Client Focus",
      description: "Our customers include RMC plants, government bodies, large infrastructure developers, builders, and specialty applicators.",
      icon: "ri-focus-3-line"
    },
    {
      title: "Sustainability & Innovation",
      description: "We constantly explore eco-friendly and innovative construction solutions that minimize environmental impact while maximizing performance. Our focus is on sustainable materials, energy-efficient processes, and future-ready technologies.",
      icon: "ri-leaf-line"
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About Lavin Enterprises & Co.
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Lavin Enterprises & Co. is a leading Pan-India distributor of high-performance construction chemicals. 
              With deep sector expertise and a strong supply network across states, we deliver technical excellence 
              and service you can trust.
            </p>
          </div>

          <div className="mb-16">
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Our Promise</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {promises.map((promise, index) => (
                  <div key={index} className="text-center">
                    <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4" style={{ backgroundColor: '#f0f0f0' }}>
                      <i className={`${promise.icon} text-2xl`} style={{ color: '#676767' }}></i>
                    </div>
                    <h4 className="text-xl font-semibold text-gray-900 mb-3">
                      {promise.title}
                    </h4>
                    <p className="text-gray-600 leading-relaxed">
                      {promise.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20construction%20team%20examining%20high-quality%20construction%20chemicals%20and%20materials%20in%20a%20modern%20warehouse%20facility%2C%20technical%20documentation%2C%20quality%20control%20equipment%2C%20industrial%20setting%20with%20organized%20chemical%20containers%20and%20professional%20staff&width=600&height=400&seq=about1&orientation=landscape"
                alt="Quality Construction Chemicals"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Technical Excellence You Can Trust
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Whether it's strengthening concrete, ensuring waterproofing, offering durable flooring solutions, 
                or sealing structural joints — we deliver technical excellence and service you can trust.
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                  <span className="text-gray-700">International quality standards compliance</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                  <span className="text-gray-700">Comprehensive technical support</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                  <span className="text-gray-700">Nationwide distribution network</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                  <span className="text-gray-700">Customized solutions for every project</span>
                </div>
              </div>
            </div>
          </div>

          {/* Our Reach & Footprint */}
          <div className="rounded-2xl p-8 md:p-12 text-white" style={{ background: 'linear-gradient(to right, #7E887E, #6B756B)' }}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold mb-6">Our Reach &amp; Footprint</h3>
                <p className="text-xl mb-6 opacity-90 leading-relaxed">
                  With operations across India, we maintain warehouses and distribution hubs in key regions to ensure consistent and timely supply.
                </p>
                <div className="space-y-4">
                  <div>
                    <div className="flex items-center mb-2">
                      <i className="ri-building-line text-xl mr-3 text-gray-200"></i>
                      <span className="font-semibold">Head Office:</span>
                    </div>
                    <p className="ml-8 opacity-90">
                      Plot No- 179, Subhash Enclave<br />
                      Sector - 72a, Tikri, Gurgaon - 122001<br />
                      Haryana
                    </p>
                  </div>
                  <div>
                    <div className="flex items-center mb-2">
                      <i className="ri-building-2-line text-xl mr-3 text-gray-200"></i>
                      <span className="font-semibold">Branch Office:</span>
                    </div>
                    <p className="ml-8 opacity-90">
                      Rain Boosting Station, NEAR KORIYAWAS MOOD<br />
                      Nizampur Road, Narnaul Mahendragarh<br />
                      Haryana, 123001
                    </p>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-handshake-line text-xl mr-3 text-gray-200"></i>
                    <span>Regional Partnerships &amp; Government Projects</span>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <img 
                  src="https://readdy.ai/api/search-image?query=India%20map%20showing%20distribution%20network%20with%20warehouse%20locations%2C%20logistics%20hubs%20marked%20across%20different%20states%2C%20professional%20supply%20chain%20visualization%2C%20modern%20distribution%20centers%20and%20delivery%20trucks%2C%20pan-India%20coverage%20representation&width=500&height=400&seq=reach1&orientation=landscape"
                  alt="Pan-India Distribution Network"
                  className="w-full h-80 object-cover rounded-xl"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
